import { render, staticRenderFns } from "./checkRemark.vue?vue&type=template&id=29c36059&scoped=true&"
import script from "./checkRemark.vue?vue&type=script&lang=js&"
export * from "./checkRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c36059",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29c36059')) {
      api.createRecord('29c36059', component.options)
    } else {
      api.reload('29c36059', component.options)
    }
    module.hot.accept("./checkRemark.vue?vue&type=template&id=29c36059&scoped=true&", function () {
      api.rerender('29c36059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/checkRemark.vue"
export default component.exports